import { DatePipe } from '@angular/common';
import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, Inject, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { Globals } from '../../globals/globals';
import { MatDatepicker, MatDatepickerIntl } from '@angular/material/datepicker';
import { getDateOnlyDisplayDate, getUtcDateOnlyTimestamp } from '../../utils/date-only.utils';

declare var $: any;

@Component({
  selector: 'teiasoft-datetime',
  templateUrl: './teiasoft-datetime.component.html',
  styleUrls: ['./teiasoft-datetime.component.scss'],
  providers: [
    // The locale would typically be provided on the root module of your application. We do it at
    // the component level here, due to limitations of our example generation script.
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
  ],
})
export class TeiasoftDatetimeComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() labelText: string = "";
  @Input() type: string = "date"; // date or datetime
  @Input() isRequired: boolean = false;
  @Input() disabled: boolean = false;
  @Input() noMargin: boolean = false;
  @Input() noMinWidth: boolean = false;
  @Input() isValid: boolean = true;
  @Input() isMobile: boolean = false;
  @Input() value?: string = "";
  @Input() size: string = "";
  @Input() showQueryDirection: boolean = false;
  @Input() selQueryDirection: string = '';
  @Input() defaultQueryDirection: string = '';
  @Input() clearValue: boolean = false;
  @Input() dateFormat: string = "";
  @Input() tabIndex: number = -1;
  @Input() readOnly: boolean = false;
  @Input() minDate: Date | null = null;
  @Input() maxDate: Date | null = null;

  @Output() onChange: EventEmitter<string> = new EventEmitter();
  selectedDate: number | null = null;
  selectedDateGt: number | null = null;
  selectedDateLt: number | null = null;
  dateTimeId: string = "";
  dtFormat: string = "yyyy-MM-dd";
  date = new FormControl();
  dateGt = new FormControl();
  dateLt = new FormControl();
  showErrorTimerId: any;

  @ViewChild('pickerFilter', { static: false }) datePickerFilter!: MatDatepicker<Date>;

  @ViewChild('picker', { read: undefined, static: false })
  datePicker!: MatDatepicker<Date>;

  @ViewChild('pickerGt', { read: undefined, static: false })
  datePickerGt!: MatDatepicker<Date>;

  @ViewChild('pickerLt', { read: undefined, static: false })
  datePickerLt!: MatDatepicker<Date>;

  constructor(private datePipe: DatePipe, private _adapter: DateAdapter<any>,
    private _intl: MatDatepickerIntl,
    @Inject(MAT_DATE_LOCALE) private _locale: string, private globals: Globals) {

  }

  ngOnInit(): void {
    this.generateId()
    this.ensureDefaultQueryDirection();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["clearValue"]) {
      this.clearValue = changes["clearValue"].currentValue;
      if (this.clearValue) {
        this.clearDataValue();
        this.selQueryDirection = this.showQueryDirection ? (this.defaultQueryDirection || '') : '';
        /* let _elem: any = document.getElementById(this.dateTimeId)!;
        if (_elem){
          _elem["value"] = this.datePipe.transform(new Date().getTime(), this.dateFormat);
          this.value = this.datePipe.transform(new Date().getTime(), this.dateFormat)!;
          this.selectedDate = null;
        }
        this.selQueryDirection = ''; */
      }
    }

    if (changes && changes["dateFormat"]) {
      this.dateFormat = changes["dateFormat"].currentValue;
    }

    if (changes && changes["value"]) {
      if (changes["value"].currentValue != null && changes["value"].currentValue != undefined && changes["value"].currentValue != '') {
        this.selectedDate = Number(changes["value"].currentValue);
        this.date.setValue(this.getDatepickerValue(this.selectedDate));
      } else if (changes["value"].currentValue === '' || changes["value"].currentValue == null) {
        this.selectedDate = null;
        this.date.setValue(null);
      }
    }

    if (changes && changes["tabIndex"]) {
      this.tabIndex = changes["tabIndex"].currentValue;
    }

    if (changes && changes["defaultQueryDirection"]) {
      this.defaultQueryDirection = changes["defaultQueryDirection"].currentValue;
    }

    if (changes && changes["showQueryDirection"]) {
      this.showQueryDirection = changes["showQueryDirection"].currentValue;
    }

    this.ensureDefaultQueryDirection();
  }

  ngAfterViewInit(): void {
    if (this.tabIndex == 0) $("#" + this.dateTimeId).focus();

    this.applyDatepickerLocale();
  }

  ngOnDestroy(): void {
    this.removeIdFromSessionStorage("TD-DATETIME-LIST", this.dateTimeId);
  }

  generateId() {
    let _list: string[] = new Array();
    if (sessionStorage.getItem("TD-DATETIME-LIST")) {
      _list = sessionStorage.getItem("TD-DATETIME-LIST")!.split(",");
      if (_list.length == 999999) {
        _list = new Array();
        sessionStorage.removeItem("TD-DATETIME-LIST");
      }
    }
    let x = this.getRandomInt(0, 999999);
    if (_list && _list.length > 0) {
      while (_list.findIndex(t => t == "TD_" + x.toString()) != -1) {
        let x = this.getRandomInt(0, 999999);
        if (_list.findIndex(t => t == "TD_" + x.toString()) == -1) break;
      }
    } else {
      _list = new Array();
    }
    _list.push("TD_" + x.toString());
    sessionStorage.setItem("TD-DATETIME-LIST", _list.join(","));
    this.dateTimeId = "TD_" + x.toString();
  }

  getRandomInt(min: number, max: number): number {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  private removeIdFromSessionStorage(storageKey: string, id: string): void {
    if (!id) {
      return;
    }

    const stored = sessionStorage.getItem(storageKey);
    if (!stored) {
      return;
    }

    const updated = stored.split(',').filter(item => item && item !== id);
    if (updated.length > 0) {
      sessionStorage.setItem(storageKey, updated.join(','));
    } else {
      sessionStorage.removeItem(storageKey);
    }
  }

  emitData() {
    if (this.showQueryDirection && this.selQueryDirection == '') return;
    if (this.showQueryDirection)
      this.onChange.emit(this.selQueryDirection + "|" + (this.selectedDate != null ? this.selectedDate!.toString() : '')); //.emit(this.datePipe.transform(this.selectedDate, this.dateFormat)! + "|" + this.selQueryDirection);
    else
      this.onChange.emit(this.selectedDate != null ? this.selectedDate!.toString() : ''); //.emit(this.datePipe.transform(this.selectedDate, this.dateFormat)!);
  }

  emitDataBetween() {
    if (this.showQueryDirection && this.selQueryDirection == '') return;
    this.onChange.emit(this.selQueryDirection + "|" + this.selectedDateGt!.toString() + "|" + this.selectedDateLt!.toString());
  }

  // GBR 05/03/2024 - MQBF-22 Validation date for manual input
  checkDate() {
    if ($("#" + this.dateTimeId).val() == '') {
      this.clearDataValue();
      this.emitData();
      return;
    }
    const rawValue = ($("#" + this.dateTimeId).val() || '').toString().trim();
    const parsedDate = this.parseDateFromDisplayValue(rawValue);
    this.selectedDate = parsedDate ? this.buildSelectedTimestamp(parsedDate) : NaN;
    this.validateDate()
    this.emitData();
  }

  validateDate() {
    let _isValid: boolean = true;
    if (this.selectedDate == undefined) _isValid = false;
    if (this.selectedDate! > 4102441199000) _isValid = false;
    if (this.selectedDate! < 0) _isValid = false;
    if (this.selectedDate!.toString() == 'NaN') _isValid = false;
    this.isValid = _isValid;
    if (this.showErrorTimerId != undefined) clearTimeout(this.showErrorTimerId);
    if (!_isValid) {
      this.selectedDate = null;
      this.date.setErrors({ 'invalid': true });
      $("#" + this.dateTimeId).val(null);
      this.showErrorTimerId = setTimeout(() => {
        this.date.setValue(null);
        this.isValid = true;
        clearTimeout(this.showErrorTimerId);
      }, 2000)
    } else {
      //this.date.setErrors(null);
    }
  }

  validateDateBetween() {
    // Reset validation
    this.dateGt.markAsUntouched();
    this.dateLt.markAsUntouched();
    this.isValid = true;
    this.dateGt.setErrors({ 'invalid': false });
    this.dateLt.setErrors({ 'invalid': false });

    let _isValidGt: boolean = true;
    let _isValidLt: boolean = true;

    if (this.selectedDateGt == undefined) _isValidGt = false;
    if (this.selectedDateLt == undefined) _isValidLt = false;

    if (this.selectedDateGt! > 4102441199000) _isValidGt = false;
    if (this.selectedDateLt! > 4102441199000) _isValidLt = false;

    if (this.selectedDateGt! < 0) _isValidGt = false;
    if (this.selectedDateLt! < 0) _isValidLt = false;

    if (this.selectedDateGt!.toString() == 'NaN') _isValidGt = false;
    if (this.selectedDateLt!.toString() == 'NaN') _isValidLt = false;

    if (this.selectedDateLt! < this.selectedDateGt!) {
      _isValidGt = false;
      _isValidLt = false;
    }

    this.isValid = _isValidGt && _isValidLt;
    if (!this.isValid) {
      this.dateGt.markAsTouched();
      this.dateLt.markAsTouched();
      this.dateGt.setErrors({ 'invalid': true });
      this.dateLt.setErrors({ 'invalid': true });
    } else {
      this.emitDataBetween();
    }
  }

  clearDataValue() {
    let _elem: any = document.getElementById(this.dateTimeId)!;
    if (_elem) {
      _elem["value"] = null;
    }

    let _elemGt: any = document.getElementById(this.dateTimeId + 'gt')!;
    if (_elemGt) {
      _elemGt["value"] = null;
    }

    let _elemLt: any = document.getElementById(this.dateTimeId + 'lt')!;
    if (_elemLt) {
      _elemLt["value"] = null;
    }

    this.value = undefined;
    this.selectedDate = null;
    this.selectedDateGt = null;
    this.selectedDateLt = null;
    this.date.setValue(null);
    this.dateGt.setValue(null);
    this.dateLt.setValue(null);
  }

  /* EVENTS */
  onChangeDate(evt: any) {
    $('#toggle_' + this.dateTimeId + ' button svg').addClass("dtp-icon-orange").removeClass('dtp-icon-orange');
    this.selectedDate = this.extractSelectedTimestamp(evt);

    if (this.selectedDate != null) {
      this.validateDate();
      this.emitData();
    }


  }

  onChangeDateBetween(evt: any, direction: string) {
    $('#toggle_' + this.dateTimeId + ' button svg').addClass("dtp-icon-orange").removeClass('dtp-icon-orange');
    const selectedTimestamp = this.extractSelectedTimestamp(evt);
    if (selectedTimestamp != null) {
      if (direction == 'gt')
        this.selectedDateGt = selectedTimestamp;
      else
        this.selectedDateLt = selectedTimestamp;
    } else {
      if (direction == 'gt')
        this.selectedDateGt = null;
      else
        this.selectedDateLt = null;
    }

    if (this.selectedDateGt != null && this.selectedDateLt != null) {
      this.validateDateBetween();
      //this.emitData();
    }

  }

  onSelectDirection(direction: string) {
    // Se cambio tipologia pulisco (ma non emitto)
    if ((this.selQueryDirection != 'ltgt' && direction == 'ltgt') || (this.selQueryDirection == 'ltgt' && direction != 'ltgt')) {
      this.clearDataValue();
      //this.onChange.emit('');
    }

    setTimeout(() => {
      if (direction == 'ltgt') {
        this.dateGt.setErrors({ 'invalid': false });
        this.dateLt.setErrors({ 'invalid': false });
        this.selQueryDirection = direction;
        if (this.selectedDateGt != null && this.selectedDateLt != null) this.emitDataBetween();
      } else {
        this.selQueryDirection = direction;
        if (this.selectedDate != null) this.emitData();
      }
    }, 250);

    //if ((direction != 'ltgt' && this.selectedDate == null) || (direction == 'ltgt' && this.selectedDateGt == null && this.selectedDateLt == null)) this.onChange.emit('');

  }

  onSelectDirection_OLD(direction: string) {
    if (this.selQueryDirection != '' && (this.selQueryDirection != direction || this.selQueryDirection == 'ltgt')) {
      this.clearDataValue();
      this.onChange.emit('');
    }

    setTimeout(() => {
      if (direction == 'ltgt') {
        this.dateGt.setErrors({ 'invalid': false });
        this.dateLt.setErrors({ 'invalid': false });
        this.selQueryDirection = direction;
        if (this.selectedDateGt != null && this.selectedDateLt != null) this.emitDataBetween();
      } else {
        this.selQueryDirection = direction;
        if (this.selectedDate != null) this.emitData();
      }
    }, 250);

    //if ((direction != 'ltgt' && this.selectedDate == null) || (direction == 'ltgt' && this.selectedDateGt == null && this.selectedDateLt == null)) this.onChange.emit('');

  }

  onClearDirection() {
    this.selQueryDirection = '';
    this.clearDataValue();
    this.onChange.emit('');
  }

  onDTToggleClick() {
    $('#toggle_' + this.dateTimeId + ' button svg').addClass("dtp-icon-orange").addClass('dtp-icon-orange');
  }

  onDTClose() {
    $('#toggle_' + this.dateTimeId + ' button svg').addClass("dtp-icon-orange").removeClass('dtp-icon-orange');
  }

  onInputKeyDown(evt: KeyboardEvent) {
    if (evt.key == 'Enter') this.datePicker.open();
    //if (evt.key == 'Tab' && this.datePicker.opened) this.datePicker.close();
  }

  openDatePicker() {
    if (this.datePickerFilter) {
      this.datePickerFilter.open();
    }
  }

  private ensureDefaultQueryDirection() {
    if (this.showQueryDirection && !this.selQueryDirection && this.defaultQueryDirection) {
      this.selQueryDirection = this.defaultQueryDirection;
    }
  }

  private applyDatepickerLocale() {
    const dateFormat = this.globals.userLogged?.dateFormat || this.dateFormat;
    this._locale = this.resolveDatepickerLocale(dateFormat);
    this._adapter.setLocale(this._locale);
    this._intl.changes.next();
    this._adapter.getFirstDayOfWeek = () => { return (dateFormat == 'MM/dd/yyyy' ? 0 : 1); };
  }

  private resolveDatepickerLocale(dateFormat?: string): string {
    const userLanguage = (this.globals.userLogged?.language || this._locale || 'it-IT').toLowerCase();

    if (dateFormat == 'MM/dd/yyyy') {
      return 'en-US';
    }

    if (userLanguage == 'en' || userLanguage.startsWith('en-')) {
      return 'en-GB';
    }

    return userLanguage;
  }

  private parseDateFromDisplayValue(value: string): Date | null {
    if (!value) return null;

    const parts = value.split(/[\/.\-]/).map(part => part.trim());
    if (parts.length !== 3) return null;

    const dateFormat = this.globals.userLogged?.dateFormat || this.dateFormat || 'dd/MM/yyyy';
    const [first, second, third] = parts.map(part => Number(part));

    if ([first, second, third].some(part => Number.isNaN(part))) {
      return null;
    }

    const day = dateFormat === 'MM/dd/yyyy' ? second : first;
    const month = dateFormat === 'MM/dd/yyyy' ? first : second;
    const year = third;

    const parsedDate = new Date(year, month - 1, day);
    if (parsedDate.getFullYear() !== year || parsedDate.getMonth() !== month - 1 || parsedDate.getDate() !== day) {
      return null;
    }

    return parsedDate;
  }

  private getDatepickerValue(value: number | null): Date | null {
    if (value == null || Number.isNaN(value)) return null;

    if (this.type === 'date') {
      return getDateOnlyDisplayDate(value);
    }

    const dateValue = new Date(value);
    return Number.isNaN(dateValue.getTime()) ? null : dateValue;
  }

  private buildSelectedTimestamp(date: Date): number | null {
    if (this.type === 'date') {
      return getUtcDateOnlyTimestamp(date);
    }

    return date.getTime();
  }

  private extractSelectedTimestamp(evt: any): number | null {
    const pickerValue = evt?.value;
    if (pickerValue instanceof Date && !Number.isNaN(pickerValue.getTime())) {
      return this.buildSelectedTimestamp(pickerValue);
    }

    const rawValue = evt?.target?.value;
    if (!rawValue) return null;

    const parsedDate = this.parseDateFromDisplayValue(rawValue.toString().trim());
    return parsedDate ? this.buildSelectedTimestamp(parsedDate) : null;
  }

}

